import { useSearchPageQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageQuery";
export var useSearchPageQueryIsError = function() {
    return useSearchPageQuery().isError;
};
